function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react'; //import "./declare";

import bwipjs from 'bwip-js';
import { barcodeTypesValues } from '../helpers/barcode';
import { PkpassBarcodeTypes } from '../../../../types';
import { createUseStyles } from 'react-jss';
import { useTheme } from '../../Theme';
export const useStyles = createUseStyles({
  squared: {
    width: ({
      theme
    }) => 110 * theme.scale,
    height: ({
      theme
    }) => 110 * theme.scale
  },
  rectangle: {
    width: ({
      theme
    }) => 230 * theme.scale,
    height: ({
      theme
    }) => 45 * theme.scale
  }
});

const Barcode = props => {
  const theme = useTheme();
  const classes = useStyles({
    theme
  });
  const canvas = React.useRef(null);
  React.useEffect(() => {
    if (canvas.current) {
      try {
        let bcid = 'qrcode';
        const size = barcodeTypesValues[props.barcodeType].isSquared ? {
          width: theme.scale * 100,
          height: theme.scale * 100
        } : {
          width: theme.scale * 230,
          height: theme.scale * 45
        };

        switch (props.barcodeType) {
          case PkpassBarcodeTypes.PKBarcodeFormatQR:
            bcid = 'qrcode'; // Barcode type

            break;

          case PkpassBarcodeTypes.PKBarcodeFormatAztec:
            bcid = 'azteccode';
            break;

          case PkpassBarcodeTypes.PKBarcodeFormatPDF417:
            bcid = 'pdf417';
            break;

          case PkpassBarcodeTypes.PKBarcodeFormatCode128:
            bcid = 'code128';
            break;
        }

        bwipjs.toCanvas(canvas.current, _objectSpread(_objectSpread({}, size), {}, {
          //padding: 3 * theme.scale,
          bcid,
          // Barcode type
          text: props.value,
          // Text to encode
          scale: 1,
          // 3x scaling factor
          textxalign: 'center',
          // Always good to set this
          barcolor: props.disabled ? 'eeeeee' : '000000'
        }));
      } catch (e) {
        console.error(e);
      }
    }
  }, [props.barcodeType, props.value, canvas, props.disabled, theme.scale]);
  return /*#__PURE__*/React.createElement("canvas", {
    ref: canvas,
    className: barcodeTypesValues[props.barcodeType].isSquared ? classes.squared : classes.rectangle
  });
};

export default Barcode;
//# sourceMappingURL=Barcode.js.map